/**
 * Tu Radar — 30-day course schedule.
 * Each day has: type, content pointers, thought prompts category.
 */

const radarSchedule = [
  // ═══════════════════════════════════
  // SEMANA 1: CONÓCETE (D1-D7)
  // ═══════════════════════════════════
  {
    day: 1, week: 1, type: 'test',
    title: 'Tu test de descubrimiento',
    description: 'Responde 36 preguntas para mapear tu personalidad y habilidades. Descubre tu tipo MBTI + tu Radar de 10 categorías.',
    videoSlot: 1,
    thoughtType: 'identidad',
    thoughtPrompts: [0, 1, 2, 3], // Indices into thoughtPrompts.identidad
  },
  {
    day: 2, week: 1, type: 'reflection',
    title: '¿Quién eres realmente?',
    description: 'Hoy exploramos tu identidad más allá de títulos y roles. ¿Qué te define cuando nadie te está viendo?',
    thoughtType: 'identidad',
    thoughtPrompts: [0, 3, 5, 6],
  },
  {
    day: 3, week: 1, type: 'reflection',
    title: 'Tu visión de vida',
    description: 'Antes de elegir qué emprender, necesitas saber qué vida quieres. Hoy diseñamos tu futuro.',
    thoughtType: 'vision',
    thoughtPrompts: [0, 1, 2, 4],
  },
  {
    day: 4, week: 1, type: 'reflection',
    title: 'Tus superpoderes',
    description: 'Todos tenemos habilidades únicas. Hoy descubrimos las tuyas y cómo monetizarlas.',
    thoughtType: 'skill',
    thoughtPrompts: [0, 2, 3, 5],
  },
  {
    day: 5, week: 1, type: 'reflection',
    title: 'Tus miedos (sin filtro)',
    description: 'El miedo es información. Hoy lo enfrentamos, lo escribimos y le quitamos poder.',
    thoughtType: 'miedo',
    thoughtPrompts: [0, 1, 2, 4],
  },
  {
    day: 6, week: 1, type: 'reflection',
    title: 'Tu combinación única',
    description: 'La intersección de tus habilidades es tu ventaja competitiva. Nadie más tiene tu combinación.',
    thoughtType: 'skill',
    thoughtPrompts: [1, 3, 4, 6],
  },
  {
    day: 7, week: 1, type: 'reflection',
    title: 'Tu primer mapa',
    description: 'Resumen de semana 1. Revisa tu MBTI, tu Radar, tus reflexiones. ¿Qué patrones ves?',
    thoughtType: 'vision',
    thoughtPrompts: [3, 5, 6, 1],
  },

  // ═══════════════════════════════════
  // SEMANA 2: EXPLORA PARTE 1 (D8-D14)
  // ═══════════════════════════════════
  {
    day: 8, week: 2, type: 'video',
    title: 'Arranca la exploración',
    description: 'Video de Bruno: cómo explorar las 31 formas sin parálisis por análisis.',
    videoSlot: 2,
    thoughtType: 'vision',
    thoughtPrompts: [0, 2, 5, 6],
  },
  {
    day: 9, week: 2, type: 'explore',
    title: 'Servicios: Freelance, Consultoría, Asistente',
    description: 'Explora 3 formas de vender tu tiempo y habilidades directamente.',
    formasIds: [1, 7, 14],
    thoughtType: 'skill',
    thoughtPrompts: [0, 2, 4, 5],
  },
  {
    day: 10, week: 2, type: 'explore',
    title: 'Comercio: E-commerce, Dropshipping, Print on Demand',
    description: 'Explora 3 formas de vender productos sin necesidad de inventario gigante.',
    formasIds: [2, 3, 18],
    thoughtType: 'accion',
    thoughtPrompts: [0, 2, 5, 6],
  },
  {
    day: 11, week: 2, type: 'explore',
    title: 'Contenido: Creador, Podcast, Newsletter',
    description: 'Explora 3 formas de monetizar tu voz y tu conocimiento.',
    formasIds: [4, 16, 17],
    thoughtType: 'vision',
    thoughtPrompts: [1, 3, 4, 6],
  },
  {
    day: 12, week: 2, type: 'explore',
    title: 'Educación: Cursos, Coaching, Tutoría',
    description: 'Explora 3 formas de enseñar lo que sabes.',
    formasIds: [5, 6, 30],
    thoughtType: 'skill',
    thoughtPrompts: [1, 4, 5, 6],
  },
  {
    day: 13, week: 2, type: 'explore',
    title: 'Creativos: Diseño, Foto/Video, Edición',
    description: 'Explora 3 formas de monetizar tu creatividad visual.',
    formasIds: [8, 15, 24],
    thoughtType: 'identidad',
    thoughtPrompts: [1, 3, 4, 6],
  },
  {
    day: 14, week: 2, type: 'reflection',
    title: 'Cierre semana 2: ¿Qué resonó?',
    description: 'De las 15 formas exploradas, ¿cuáles te emocionaron? ¿Cuáles descartaste?',
    thoughtType: 'vision',
    thoughtPrompts: [2, 3, 5, 6],
  },

  // ═══════════════════════════════════
  // SEMANA 3: EXPLORA PARTE 2 (D15-D21)
  // ═══════════════════════════════════
  {
    day: 15, week: 3, type: 'video',
    title: 'Profundiza en lo que resonó',
    description: 'Video de Bruno: cómo pasar de "me interesa" a "puedo hacerlo".',
    videoSlot: 3,
    thoughtType: 'identidad',
    thoughtPrompts: [2, 4, 5, 6],
  },
  {
    day: 16, week: 3, type: 'explore',
    title: 'Marketing: Ads, SEO, Community Management',
    description: 'Explora 3 formas de ayudar a otros negocios a crecer.',
    formasIds: [10, 11, 25],
    thoughtType: 'accion',
    thoughtPrompts: [1, 2, 3, 6],
  },
  {
    day: 17, week: 3, type: 'explore',
    title: 'Tech: Desarrollo, SaaS, Automatización',
    description: 'Explora 3 formas técnicas de crear valor digital.',
    formasIds: [9, 20, 28],
    thoughtType: 'skill',
    thoughtPrompts: [0, 2, 3, 6],
  },
  {
    day: 18, week: 3, type: 'explore',
    title: 'Mixtos: Afiliados, Copywriting, Traducción',
    description: 'Explora 3 formas que combinan habilidades diversas.',
    formasIds: [19, 12, 13],
    thoughtType: 'accion',
    thoughtPrompts: [2, 3, 5, 6],
  },
  {
    day: 19, week: 3, type: 'explore',
    title: 'Avanzados: Marketplace, Membresías, Eventos',
    description: 'Explora 3 formas que requieren más experiencia pero escalan más.',
    formasIds: [21, 27, 26],
    thoughtType: 'vision',
    thoughtPrompts: [0, 1, 5, 6],
  },
  {
    day: 20, week: 3, type: 'explore',
    title: 'Creativos+: Arte Digital, Música, Nómada',
    description: 'Explora las últimas 3 formas: lifestyle y creatividad pura.',
    formasIds: [22, 23, 31],
    thoughtType: 'identidad',
    thoughtPrompts: [0, 3, 5, 6],
  },
  {
    day: 21, week: 3, type: 'reflection',
    title: 'Tu top 5 finalistas',
    description: 'De las 31 formas, elige tus 5 favoritas. Escribe por qué cada una te atrae.',
    thoughtType: 'vision',
    thoughtPrompts: [1, 2, 4, 6],
  },

  // ═══════════════════════════════════
  // SEMANA 4: TU DECISIÓN (D22-D30)
  // ═══════════════════════════════════
  {
    day: 22, week: 4, type: 'video',
    title: 'Es hora de decidir',
    description: 'Video de Bruno: cómo elegir sin arrepentirte.',
    videoSlot: 4,
    thoughtType: 'miedo',
    thoughtPrompts: [0, 1, 3, 4],
  },
  {
    day: 23, week: 4, type: 'decision',
    title: 'Matriz de viabilidad',
    description: 'Evalúa tus top 5 con criterios reales: capital, tiempo, habilidades, mercado.',
    thoughtType: 'accion',
    thoughtPrompts: [0, 1, 5, 6],
  },
  {
    day: 24, week: 4, type: 'decision',
    title: 'Tu top 3',
    description: 'Reduce a 3 opciones. Escribe qué ganas y qué pierdes con cada una.',
    thoughtType: 'vision',
    thoughtPrompts: [1, 3, 5, 6],
  },
  {
    day: 25, week: 4, type: 'decision',
    title: 'Obstáculos reales',
    description: 'Para cada top 3: ¿qué podría salir mal? ¿Cómo lo resolverías?',
    thoughtType: 'miedo',
    thoughtPrompts: [1, 2, 4, 5],
  },
  {
    day: 26, week: 4, type: 'decision',
    title: 'Consulta con Genio & Luca',
    description: 'Sesión especial donde Genio y Luca te dan perspectiva sobre tus top 3.',
    thoughtType: 'accion',
    thoughtPrompts: [2, 3, 4, 6],
  },
  {
    day: 27, week: 4, type: 'decision',
    title: 'TU DECISIÓN',
    description: 'Elige UNA forma. La que vas a empezar. Escríbelo como compromiso público.',
    thoughtType: 'accion',
    thoughtPrompts: [0, 2, 5, 6],
  },
  {
    day: 28, week: 4, type: 'decision',
    title: 'Tu primer paso',
    description: 'Ejecuta la primera acción concreta. No planees más. HAZ.',
    thoughtType: 'accion',
    thoughtPrompts: [0, 1, 3, 5],
  },
  {
    day: 29, week: 4, type: 'reflection',
    title: 'Reflexión del proceso',
    description: '¿Qué aprendiste de ti en estos 30 días? ¿Qué te sorprendió?',
    thoughtType: 'identidad',
    thoughtPrompts: [0, 3, 5, 6],
  },
  {
    day: 30, week: 4, type: 'video',
    title: 'Graduación Tu Radar 🎉',
    description: 'Video de cierre de Bruno. Tu neurona en la red ya brilla con tu decisión.',
    videoSlot: 5,
    thoughtType: 'vision',
    thoughtPrompts: [0, 1, 5, 6],
  },
];

export default radarSchedule;
